import Super from '@simplepractice/ember-messaging-client/serializers/messaging-message';

export default Super.extend({});
